import React from 'react';
import { Button, DatePicker, Form, Modal, Select } from 'antd';

const { Option } = Select;

interface ExamModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (show: boolean) => void;
    form: any;
    projectId: number;
    projectName: string;
    subjects: {
        subjectId: number;
        subjectName: string;
    }[];
    handleSaveExam: () => void;
    currentEditExamId: React.MutableRefObject<number>;
}

const ExamModal: React.FC<ExamModalProps> = ({
    isModalOpen,
    setIsModalOpen,
    form,
    projectId,
    projectName,
    subjects,
    handleSaveExam,
    currentEditExamId,
}) => {
    return (
        <Modal
            wrapClassName="add-exam-modal-wrap"
            title={currentEditExamId.current ? '编辑考试' : '添加考试'}
            width={450}
            open={isModalOpen}
            centered
            footer={
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button style={{ width: 240 }} onClick={handleSaveExam} type="primary">
                        {currentEditExamId.current ? '保存设置' : '添加考试时间'}
                    </Button>
                </div>
            }
            onOk={handleSaveExam}
            onCancel={() => setIsModalOpen(false)}
        >
            <Form
                name="basic"
                labelCol={{ span: 0 }}
                wrapperCol={{ span: 24 }}
                style={{ maxWidth: 600 }}
                initialValues={{ remember: true }}
                autoComplete="off"
                form={form}
            >
                <Form.Item name="projectId">
                    <Select disabled>
                        <Option value={projectId}>{projectName}</Option>
                    </Select>
                </Form.Item>

                <Form.Item name="subjectId" rules={[{ required: true, message: '请选择科目' }]}>
                    <Select placeholder="考试科目">
                        {subjects.map(item => (
                            <Option key={item.subjectId} value={item.subjectId}>
                                {item.subjectName}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item name="examDate" rules={[{ required: true, message: '请选择考试科目' }]}>
                    <DatePicker placeholder="考试时间" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ExamModal;
